import { reactive, computed } from '@nuxtjs/composition-api';
const isMobileDevice = () => {
  return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1 || window.innerWidth < 768);
};
const state = reactive({
  isCartSidebarOpen: false,
  isWishlistSidebarOpen: false,
  isLoginModalOpen: false,
  isNewsletterModalOpen: false,
  isCategoryGridView: true,
  isFilterSidebarOpen: false,
  isMobileMenuOpen: false,
  isMobile: false,
  isSearchItemOpen: false,
  isMessageSidebarOpen: false
});

const useUiState = (): any => {
  const isMobile = computed(() => state.isMobile);
  const resize = () => {
    // const mq = window.matchMedia('(max-width: 1024px)');
    // mq.matches
    const Mobile = isMobileDevice();
    if (Mobile) {
      state.isMobile = true;
      // console.log('isMobile: true');
    } else {
      state.isMobile = false;
      // console.log('isMobile: false');
    }
  };
  const isMobileMenuOpen = computed(() => state.isMobileMenuOpen);
  const toggleMobileMenu = () => {
    state.isMobileMenuOpen = !state.isMobileMenuOpen;
  };

  const isCartSidebarOpen = computed(() => state.isCartSidebarOpen);
  const toggleCartSidebar = () => {
    if (state.isMobileMenuOpen) toggleMobileMenu();
    state.isCartSidebarOpen = !state.isCartSidebarOpen;
  };

  const isWishlistSidebarOpen = computed(() => state.isWishlistSidebarOpen);
  const toggleWishlistSidebar = () => {
    if (state.isMobileMenuOpen) toggleMobileMenu();
    state.isWishlistSidebarOpen = !state.isWishlistSidebarOpen;
  };

  const isMessageSidebarOpen = computed(() => state.isMessageSidebarOpen);
  const toggleMessageSidebar = () => {
    if (state.isMobileMenuOpen) toggleMobileMenu();
    state.isMessageSidebarOpen = !state.isMessageSidebarOpen;
  };

  const isLoginModalOpen = computed(() => state.isLoginModalOpen);
  const toggleLoginModal = () => {
    if (state.isMobileMenuOpen) toggleMobileMenu();
    state.isLoginModalOpen = !state.isLoginModalOpen;
  };

  const isNewsletterModalOpen = computed(() => state.isNewsletterModalOpen);
  const toggleNewsletterModal = () => {
    state.isNewsletterModalOpen = !state.isNewsletterModalOpen;
  };

  const isCategoryGridView = computed(() => state.isCategoryGridView);
  const changeToCategoryGridView = () => {
    state.isCategoryGridView = true;
  };
  const changeToCategoryListView = () => {
    state.isCategoryGridView = false;
  };

  const isFilterSidebarOpen = computed(() => state.isFilterSidebarOpen);
  const toggleFilterSidebar = () => {
    state.isFilterSidebarOpen = !state.isFilterSidebarOpen;
  };

  const isSearchItemOpen = computed(() => state.isSearchItemOpen);
  const toggleSearchItem = () => {
    state.isSearchItemOpen = !state.isSearchItemOpen;
  };

  return {
    isCartSidebarOpen,
    isWishlistSidebarOpen,
    isLoginModalOpen,
    isNewsletterModalOpen,
    isCategoryGridView,
    isFilterSidebarOpen,
    isMobileMenuOpen,
    isMobile,
    toggleCartSidebar,
    toggleWishlistSidebar,
    toggleLoginModal,
    toggleNewsletterModal,
    changeToCategoryGridView,
    changeToCategoryListView,
    toggleFilterSidebar,
    toggleMobileMenu,
    isSearchItemOpen,
    toggleSearchItem,
    isMessageSidebarOpen,
    toggleMessageSidebar,
    resize
  };
};

export default useUiState;
